<template>
  <table
    :style="styles"
    cellspacing="0"
    cellpadding="0"
    border="0"
  >
    <colgroup>
      <col
        v-for="column in columns"
        :key="column.key"
        :width="setCellWidth(column)"
      >

      <col
        v-if="$parent.showVerticalScrollBar"
        :width="$parent.scrollBarWidth">
    </colgroup>
    <thead>
      <tr>
        <table-th-header
          v-for="(column, index) in columns"
          :key="column.key"
          :index="index"
          :column="column"
        />

        <th v-if="$parent.showVerticalScrollBar" />
      </tr>
      <tr class="gdl-table-filters">
        <table-th-filter
          v-for="(column, index) in columns"
          :key="column.key"
          :index="index"
          :column="column"
        />

        <th v-if="$parent.showVerticalScrollBar" />
      </tr>
    </thead>
  </table>
</template>
<script>
import Mixin from './mixin';
import TableThHeader from './table-th-header.vue';
import TableThFilter from './table-th-filter.vue';

export default {
  name: 'TableHead',
  components: { TableThHeader, TableThFilter },
  mixins: [Mixin],
  inject: ['table'],
  props: {
    columns: { type: Array, required: true },
    styleObject: { type: Object, required: true },
  },
  computed: {
    styles() {
      const style = Object.assign({}, this.styleObject);
      const width = parseInt(this.styleObject.width, 10);
      style.width = `${width}px`;
      return style;
    },
  },
};
</script>
